import { io } from "socket.io-client";
class SocketioService {
  socket;
  setupSocketConnection() {
    this.socket = io("https://browsertimer.hire3x.com"); // Staging
  }
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.emit("message", "pause timer")
    }

  }
}
export default new SocketioService();
